import { useState } from 'react'
import { jt, t } from 'ttag'

import { Link } from '@h2/common/components/link'
import { useTitleChange } from '@main/util/hooks'

/**
 * Library
 *
 *
 *
 *
 *
 */
const SelectLibraryDistrict = () => {
  useTitleChange(t`Nevada Library System`)
  const [selectedLibrary, setSelectedLibrary] = useState(null)
  const libraries = [
    {
      isLibrary: true,
      name: 'Las Vegas-Clark County Library District',
      moreInfoUrl: 'https://ilsweb.lvccld.org/selfreg~S12'
    },
    {
      isLibrary: true,
      name: 'North Las Vegas Library District',
      moreInfoUrl: 'http://www.cityofnorthlasvegas.com/departments/library/index.php'
    },
    {
      isLibrary: true,
      name: 'Boulder City Libraries',
      moreInfoUrl: 'https://bclibrary.org/'
    },
    {
      isLibrary: true,
      name: 'Henderson Libraries',
      moreInfoUrl: 'https://hendersonlibraries.com/'
    },
    {
      isLibrary: true,
      name: 'Churchill County Library',
      moreInfoUrl: 'https://www.churchillcountylibrary.org/'
    },
    {
      isLibrary: true,
      name: 'Amargosa Valley Library District',
      moreInfoUrl: 'http://www.amargosalibrary.com/'
    },
    {
      isLibrary: true,
      name: 'Beatty Library District',
      moreInfoUrl: 'http://beattylibrarydistrict.org/'
    },
    {
      isLibrary: true,
      name: 'Carson City Library',
      moreInfoUrl: 'https://www.carsoncitylibrary.org/'
    },
    {
      isLibrary: true,
      name: 'Douglas County Library',
      moreInfoUrl: 'https://www.dcl.org/'
    },
    {
      isLibrary: true,
      name: 'Elko-Lander-Eureka Library System',
      moreInfoUrl: 'http://www.elkocountylibrary.org/'
    },
    {
      isLibrary: true,
      name: 'Esmeralda County Libraries',
      moreInfoUrl: 'http://www.clan.lib.nv.us/polpac/library/clan/esmeralda.htm'
    },

    {
      isLibrary: true,
      name: 'Humboldt County Library',
      moreInfoUrl: 'https://www.hcnv.us/351/Library'
    },
    {
      isLibrary: true,
      name: 'Lincoln County Library',
      moreInfoUrl: 'http://www.clan.lib.nv.us/polpac/library/clan/lincoln.htm'
    },
    {
      isLibrary: true,
      name: 'Lyon County Library',
      moreInfoUrl: 'https://www.lyon-county.org/238/Library'
    },
    {
      isLibrary: true,
      name: 'Mineral County Library',
      moreInfoUrl: 'http://www.mineralcountynv.us/departments/library.php'
    },
    {
      isLibrary: true,
      name: 'Pahrump Library District',
      moreInfoUrl: 'https://www.pahrumplibrary.org/'
    },
    {
      isLibrary: true,
      name: 'Pershing County Library',
      moreInfoUrl: 'http://pershingcounty.net/community/county_library/'
    },
    {
      isLibrary: true,
      name: 'Smoky Valley Library District',
      moreInfoUrl: 'https://www.svld.net/'
    },
    {
      isLibrary: true,
      name: 'Storey County Community Library',
      moreInfoUrl: 'https://communitychestnevada.net/storey-library/'
    },
    {
      isLibrary: true,
      name: 'Tonopah Library District',
      moreInfoUrl: 'http://www.tonopahnevada.com/tonopahlibrary/'
    },
    {
      isLibrary: true,
      name: 'Washoe County Library',
      moreInfoUrl: 'https://www.washoecountylibrary.us/'
    },
    {
      isLibrary: true,
      name: 'White Pine County Library',
      moreInfoUrl: 'https://www.whitepinecounty.net/284/Library'
    },
    {
      name: "I Don't See My Library District",
      isLibrary: false,
      cssClass: 'no-initial-style',
      moreInfoText: `If you aren't a member of one of the library districts below, click the button below to let us know
                that you'd like to be contacted when we expand to more areas.`,
      link: {
        localLink: true,
        url: '/help/reportissue',
        text: t`Send us a message`
      }
    }
  ]
    .sort((lib1, lib2) => lib1.name.localeCompare(lib2.name))
    .sort((lib1, lib2) => {
      if (lib1.isLibrary === lib2.isLibrary) {
        return 0
      }

      if (lib1.isLibrary) {
        return -1
      }

      if (lib2.isLibrary) {
        return 1
      }
    })

  /**
   * libraries: libraries.sort((a,b) => a.name.localeCompare(b.name)).sort((a,b) => {
   *            if(a.isLibrary === b.isLibrary) return 0;
   *            if(a.isLibrary) return -1;
   *            if(b.isLibrary) return 1;
   *        })
   * @returns {JSX.Element|null}
   */

  const outputButtons = () => {
    if (!selectedLibrary) {
      return null
    }

    if (selectedLibrary.isLibrary) {
      const boldedName = <b key="library-name">{selectedLibrary.name}</b>

      return (
        <div>
          <p>{jt`To find out more about obtaining a library card at ${boldedName}, please visit the link below:`}</p>
          <a href={selectedLibrary.moreInfoUrl} className="btn btn-primary btn-full">
            {`Visit Library Website`}
          </a>
        </div>
      )
    }

    return (
      <div>
        <p>{selectedLibrary.moreInfoText}</p>
        <Link
          ssr={!selectedLibrary.link.localLink}
          href={selectedLibrary.link.url}
          className="btn btn-primary btn-full">
          {selectedLibrary.link.text}
        </Link>
      </div>
    )
  }

  return (
    <div className="container">
      <p>
        {jt`Account registration is currently only available to patrons of library districts in Nevada.`}
      </p>
      <h4>{t`Which is your local library?`}</h4>
      <div
        className={`library-choice-container ${
          selectedLibrary ? 'with-selection' : 'without-selection'
        }`}
        style={{ position: 'relative' }}>
        <div
          className="library-choice-options"
          style={{ maxHeight: '55vh', overflow: 'scroll' }}>
          {libraries.map(library => {
            const css1 =
              library?.name === selectedLibrary?.name
                ? 'selected-library'
                : 'unselected-library'
            const css2 = library.cssClass ? library.cssClass : ''

            return (
              <p key={library.name}>
                <button
                  style={{ padding: '0px 5px' }}
                  className={`${css1} ${css2}`}
                  onClick={() => setSelectedLibrary(library)}>
                  {library.name}
                </button>
              </p>
            )
          })}
        </div>
        <div className={'library-choice-selected'}>{outputButtons()}</div>
      </div>
    </div>
  )
}

SelectLibraryDistrict.propTypes = {}
SelectLibraryDistrict.defaultProps = {}

export default SelectLibraryDistrict
